import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Toggle from "../../../components/common/Toggle";
import { useToast } from "../../../contexts/ToastContext";
import { setCurrentProject } from "../../../redux/project/projectSlice";
import { projectsService } from "../../../services/projects";
import { sitePath } from "../../../utils/urls";
import Templates from "../Templates";

const Seo = () => {
  const dispatch = useDispatch();
  const project = useSelector((state) => state.project.currentProject);
  const { info } = useToast();
  const discoverable = Boolean(project?.discoverable);

  const toggleDiscoverable = () => {
    projectsService.updateProject(
      project.hash,
      { discoverable: !discoverable },
      (response) => {
        dispatch(setCurrentProject(response.data));
        info(
          <>
            Redeploy the site so robots and sitemap match this setting.{" "}
            <Link to={sitePath(project, "deploys/")} className="underline font-semibold">
              Open deploys
            </Link>
          </>,
          8000,
          { key: "discoverable-redeploy" },
        );
      },
    );
  };

  return (
    <div className="max-w-3xl space-y-8">
      <section>
        <div className="rounded-xl border border-theme-secondary p-5">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-sm font-medium">Discoverable</p>
              <p className="mt-1 text-xs opacity-60">
                {discoverable
                  ? "Search engines can index pages you allow on Templates, and a sitemap is generated."
                  : "Search discovery is off, so every page is noindex and no sitemap is published. Turn on Discoverable to change index and sitemap options per template."}
              </p>
            </div>
            <Toggle
              checked={discoverable}
              label="Discoverable"
              onChange={toggleDiscoverable}
            />
          </div>
        </div>
      </section>

      <Templates />
    </div>
  );
};

export default Seo;
